export const CREATE_COATING_AFTER = 'CREATE_COATING_AFTER'
export const UPDATE_COATING_AFTER = 'UPDATE_COATING_AFTER'
export const DELETE_COATING_AFTER = 'DELETE_COATING_AFTER'
export const GET_ALL_COATING_AFTERS_SUCCESS = 'GET_ALL_COATING_AFTERS_SUCCESS'
export const GET_ALL_COATING_AFTERS_ERROR = 'GET_ALL_COATING_AFTERS_ERROR'
